module.exports = __webpack_public_path__ + "static/media/hot-offer.4341f309.png";